// utils/config.js
const config = {
  // 开发环境
  development: {
    h5: {
      baseURL: '/api'
    },
    'mp-weixin': {
      baseURL: 'https://opo.qduh.cn'
      // 或者本地测试：baseURL: 'http://192.168.100.10:8080'
    },
    'app-plus': {
      baseURL: 'http://192.168.100.10:8080'
    }
  },
  // 生产环境
  production: {
    h5: {
      baseURL: 'https://opo.qduh.cn'
    },
    'mp-weixin': {
      baseURL: 'https://opo.qduh.cn'
    },
    'app-plus': {
      baseURL: 'https://opo.qduh.cn'
    }
  }
};

// 获取当前配置
const getConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  const platform = process.env.VUE_APP_PLATFORM || 'h5';
  
  return {
    ...config[env][platform] || config[env].h5,
    env,
    platform
  };
};

export default getConfig;